import { type HeartbeatState, type TemplateStanding } from "@starsach/shared-types";
import { Hint } from "./Hint";
import { StatusPill } from "./ui";

/** The heartbeat as the Customers list and the environment header show it; the three-hour line is `heartbeatState` (#329). */
export function HeartbeatPill({ state }: { state: HeartbeatState }) {
  if (state === "reporting") return <StatusPill status="reporting" tone="ok" />;
  if (state === "quiet") return <StatusPill status="no heartbeat" tone="warning" />;
  return (
    <span className="inline-flex items-center">
      <StatusPill status="waiting for first heartbeat" tone="neutral" />
      <Hint id="customers.waiting-heartbeat" label="waiting for first heartbeat" />
    </span>
  );
}

/** Behind or ahead of the current template by semver; nothing when current or unknown (#329). */
export function TemplateStandingPill({ standing }: { standing: TemplateStanding }) {
  if (standing === "behind") return <StatusPill status="behind" tone="warning" />;
  if (standing !== "ahead") return null;
  return (
    <span className="inline-flex items-center">
      <StatusPill status="ahead" tone="neutral" />
      <Hint id="customers.template-ahead" label="ahead of the current template" />
    </span>
  );
}
